<template>
	<v-container fluid>
		<v-row>
		  <v-col cols="12">
			  <p>
				I choose pay my dues by payroll dues deduction. I understand that I also must notify my employers payroll office to provide my authorization.<span v-if="HasAuthForm" class="pl-1">For your convenience your districts authorization form is available by clicking the button below.</span>
			  </p>
			  <v-btn
			  		v-if="HasAuthForm"
					@click="downloadFile(`${$baseURL}/common/application/authForm.php?key=${UnitKey}`)"
					style="background-color:var(--meablue);color:white;"
				>Download Authorization Form</v-btn>
		  </v-col>
		</v-row>
		<terms-and-conditions-dialog :showDialog="show_main_terms" :termsDetails="$store.getters.getMainTerms" @close-dialog="show_main_terms=false"></terms-and-conditions-dialog>
	</v-container>
  </template>
  
  <script>
  import TermsAndConditionsDialog from '../DialogComponents/TermsAndConditionsDialog.vue'
	//import axios from 'axios'
	export default {
	  name: 'IpddPayrollDeduct',
	  props: {
		HasAuthForm: Boolean,
		UnitKey: String
	  },
	  components:
	  {
		  TermsAndConditionsDialog
	  },
	  data:() => ({        
		  show_main_terms:false
	  }),
	  methods:{      
		downloadFile(url){
			window.open(url,'_blank');
		}  
	  },
	  mounted:function(){
  
	  },
	  watch:{        
	  }
	}
  </script>
  
  <style scoped>
  </style>